import { render, staticRenderFns } from "./Subtitle.vue?vue&type=template&id=68ae176c&scoped=true"
import script from "./Subtitle.vue?vue&type=script&lang=js"
export * from "./Subtitle.vue?vue&type=script&lang=js"
import style0 from "./Subtitle.vue?vue&type=style&index=0&id=68ae176c&prod&lang=css"
import style1 from "./Subtitle.vue?vue&type=style&index=1&id=68ae176c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ae176c",
  null
  
)

export default component.exports